import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { Product } from './pages/Product';
import { WhyNotHubspot } from './pages/WhyNotHubspot';
import { UseCases } from './pages/UseCases';
import { BookDemo } from './pages/BookDemo';
import { useScreenInit } from './useScreenInit';
export function App() {
  useScreenInit();
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Layout data-id="element-3" />} data-id="element-2">
          <Route index element={<Home data-id="element-5" />} data-id="element-4" />
          <Route path="product" element={<Product data-id="element-7" />} data-id="element-6" />
          <Route path="why-not-hubspot-workflows" element={<WhyNotHubspot data-id="element-9" />} data-id="element-8" />
          <Route path="use-cases" element={<UseCases data-id="element-11" />} data-id="element-10" />
          <Route path="book-a-demo" element={<BookDemo data-id="element-13" />} data-id="element-12" />
        </Route>
      </Routes>
    </BrowserRouter>;
}